import HTTP from "@/_helpers/http";
import { FAQS__API } from "@/_helpers/urls";
import { FAQS__MUTATIONS } from "../mutation-types";
import { FAQS__ACTIONS } from "../action-types";

// State
const state = {
  faqs: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [FAQS__MUTATIONS.FAQS](state, data) {
    state.faqs = data;
  },
};
// Actions
const actions = {
  async [FAQS__ACTIONS.FAQS]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(FAQS__API.FAQS);
      commit(FAQS__MUTATIONS.FAQS, response.data);
    } catch (error) {
      console.log(error);
    }
  }
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
